import Router from 'next/router'
import qs from 'query-string'

function getFilters(query: string, category?: string) {
  const base64 = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/

  if (!base64.test(query)) {
    Router.ready(() => {
      //eslint-disable-next-line
      const { filters, ...params } = Router.query
      Router.replace({ query: params }, undefined, { shallow: true })
    })

    return
  }

  const decodedQuery = window.atob(query)
  const parsedQuery = qs.parse(decodedQuery, {
    arrayFormat: 'separator',
    arrayFormatSeparator: '|',
    parseNumbers: false,
  })

  const filters = Object.entries(parsedQuery).reduce(
    (filters: Record<string, any>, [key, ids]) => {
      if (ids) filters[key] = [ids].flat().filter((id) => id)
      return filters
    },
    {}
  )

  if (category) return filters[category] || []

  return filters
}

export default getFilters
